<template>
  <div class="student-course-panel"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <template v-if="courseInfo">
      <AppScrollbar style="height: 100%">
        <div class="info-main">
          <TitleGroup v-if="courseInfo.archive"
                      fold>
            <template #title>
              <i class="el-icon-data-line"></i>
              <span class="title">入学考试成绩</span>
            </template>
            <div class="info-wrap">
              <el-form size="mini"
                       label-width="80px"
                       label-suffix="：">
                <el-row type="flex"
                        :gutter="20">
                  <el-col :span="6">
                    <el-form-item label="英语分数">
                      <div class="value">{{courseInfo.archive.englishScore}}</div>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="综合分数">
                      <div class="value">{{courseInfo.archive.synthesisScore}}</div>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="面试分数">
                      <div class="value">{{courseInfo.archive.interviewScore}}</div>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="总分">
                      <div class="value">{{courseInfo.archive.totalScore}}</div>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </TitleGroup>
          <TitleGroup fold>
            <template #title>
              <i class="el-icon-data-analysis"></i>
              <span class="title">课程成绩详情</span>
            </template>
            <div class="info-wrap">
              <StudentCoursePerformancePanel :student-id="studentId"
                                             v-bind="courseInfo"></StudentCoursePerformancePanel>
            </div>
          </TitleGroup>
          <TitleGroup v-if="courseInfo.changes && courseInfo.changes.length"
                      fold>
            <template #title>
              <i class="el-icon-place"></i>
              <span class="title">学籍异动情况</span>
            </template>
            <div class="info-wrap">
              <el-timeline>
                <el-timeline-item v-for="change in courseInfo.changes"
                                  :key="change.id">
                  <div class="change">
                    <span class="operator">{{change.operator}}</span>
                    <span>进行了</span>
                    <span class="theme-text">{{change.changeType}}</span>
                    <span>异动，异动时间：</span>
                    <span class="date">{{change.changeDate}}</span>
                    <span>；</span>
                  </div>
                </el-timeline-item>
              </el-timeline>
            </div>
          </TitleGroup>
        </div>
      </AppScrollbar>
    </template>
    <template v-else>
      <Hint v-if="!loading"
            type="error">
        <span>课程数据加载失败</span>
        <el-button type="text"
                   @click="loadCourseInfo">重新加载</el-button>
      </Hint>
    </template>
  </div>
</template>

<script>
import AppScrollbar from '../../../../../../../elements/AppScrollbar'
import TitleGroup from '../../../../../../../widgets/custom/TitleGroup'
import StudentCoursePerformancePanel from './performance'
import Hint from '../../../../../../../elements/Hint'
export default {
  name: 'StudentCoursePanel',
  components: {
    AppScrollbar,
    TitleGroup,
    StudentCoursePerformancePanel,
    Hint
  },
  props: {
    studentId: {
      type: String,
      required: true
    },
    visible: Boolean
  },
  data () {
    return {
      loading: false,
      courseInfo: null
    }
  },
  methods: {
    loadCourseInfo () {
      this.$emit('start-refresh')
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/portal/student/info/course',
        method: 'post',
        data: this.$qs.stringify({
          studentId: this.studentId
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.courseInfo = response.data['courseInfo'] || {}
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
        this.$emit('end-refresh')
      })
    }
  },
  mounted () {
    this.loadCourseInfo()
  },
  watch: {
    visible (val) {
      if (val) {
        this.loadCourseInfo()
      }
    }
  }
}
</script>

<style lang="scss">
  .student-course-panel {
    height: 100%;
    background-color: #fff;
    .info-main {
      padding: 15px;
      .title-group {
        &:last-child {
          .info-wrap {
            .vxe-table {
              padding-bottom: 0;
            }
          }
        }
        &.edit-mode {
          & > .main {
            .info-wrap {
              .el-form {
                margin-top: 12px;
                &--label-top {
                  margin-top: 2px;
                }
                .el-form-item {
                  margin-bottom: 12px;
                }
              }
            }
          }
        }
        & > .main {
          margin-top: 0;
          .info-wrap {
            .el-form {
              padding: 6px 0 4px 18px;
              &--label-top {
                .el-form-item {
                  .el-form-item__label {
                    padding-bottom: 2px;
                  }
                }
              }
              .el-form-item {
                margin-bottom: 4px;
                &.required {
                  .el-form-item__label {
                    position: relative;
                    &:before {
                      content: '*';
                      position: absolute;
                      left: -10px;
                      color: #f56c6c;
                    }
                  }
                }
                .el-form-item__label {
                  color: #909399;
                  font-size: 12px;
                  text-align: left;
                  white-space: nowrap;
                }
                .el-form-item__content {
                  font-size: 12px;
                  .value {
                    color: #303133;
                    word-break: break-all;
                    word-wrap: break-word;
                    &.pre {
                      white-space: pre-wrap;
                    }
                    &:empty {
                      &:before {
                        content: '\002f';
                        color: #909399;
                      }
                    }
                  }
                  .el-input,
                  .el-select {
                    width: 200px;
                    max-width: 100%;
                  }
                }
              }
              .el-row--flex {
                flex-wrap: wrap;
              }
            }
            .el-timeline {
              margin: 15px 0 0 0;
              padding: 5px 0 0 12px;
              .el-timeline-item {
                padding-bottom: 5px;
                &:last-child {
                  padding-bottom: 0;
                }
                .el-timeline-item__node {
                  left: 1px;
                  width: 8px;
                  height: 8px;
                }
                .el-timeline-item__wrapper {
                  top: -5px;
                  padding-left: 24px;
                  padding-right: 10px;
                  .el-timeline-item__content {
                    .change {
                      color: #909399;
                      font-size: 12px;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
</style>
